<template>
  <div>
    <!-- <hero-banner :title="title"></hero-banner> -->
    <nav class="d-none d-md-block" aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-arrow">
        <li class="breadcrumb-item">
          <router-link to="/" style="color:#666666">Home</router-link>
        </li>

        <li class="breadcrumb-item active">{{title}}</li>
      </ol>
    </nav>

    <div class="my-5 container">
      <div class="row" >
        <div class="col-md-10 offset-md-1" >
          <div class="terms-list">
            <div class="row " >
              <div class="col-md-6 col-sm-6 mb-5">
                <el-card shadow="always"><div class="awardinfo">
                    <h6>Chartered Institute of Marketing, Ghana</h6>
                    <p>
                      Motor firm of the year 2018
                      <br />Outdoor Advert of the Year 2008
                      <br />Motor firm of the year 2007
                    </p>
                  </div></el-card>
              </div>
              <div class="col-md-6 col-sm-6 mb-5">
                <el-card shadow="always"> <div class="awardinfo">
                    <h6>Societe Distribution International (SDI)</h6>
                    <p>
                      Best-selling in Passenger Cars in the region, 2011
                      <br />
Best-selling in Passenger Cars in the region, 2010
                    </p>
                  </div></el-card>
              </div>
              <div class="col-md-6 col-sm-6 mb-5">
                <el-card shadow="always">  <div class="awardinfo">
                    <h6>Ghana Auto Awards</h6>
                    <p>
                      Best 4x4, Mercedes-Benz GLS 63, 2017
                      <br />Best Interior, Mercedes-Benz S-Class, 2017
                      <br />Best SUV, Mercedes-Benz (G63), 2017
                      <br />Safety Award of the year, Mercedes-Benz (E-200), 2017
                      <br />Motor firm of the year- 2016
                      <br />Micro Car of the year, Suzuki Swift Dzire, 2016
                      <br />
Discovery of the year, Suzuki, 2016
                    </p>
                  </div></el-card>
              </div>
              <div class="col-md-6 col-sm-6 mb-5">
                <el-card shadow="always"> <div class="awardinfo">
                    <h6>Others</h6>
                    <p>
                    2nd Ghana Procurement & Supply Chain Awards, Excellence in Procurement& Supply Chain Automobile- 2018 
                      <br />
GPIC/Ghana Club 100, Market leader in the Ghanaian Premier Auto Industry- 2006
                    </p>
                  </div></el-card>
              </div>
              <div class="col-md-6 col-sm-6 mb-5">
                <el-card shadow="always"> <div class="awardinfo">
                    <h6>Suzuki Automobile Distributors Conference, New Delhi</h6>
                    <p>
                     Runner-Up, Highest Market Share in 2017, Africa Group 1, 2017
                      <br />
Winner, Highest Repair Order Growth in 2017 Africa, 2017
                    </p>
                  </div></el-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
// import TopHeroBanner from "@/components/TopHeroBanner1.vue";
import CoreValues from "../components/Core.vue";
export default {
  components: {core: CoreValues },
  name: "milestone",
  data() {
    return {
      title: "Milestones"
    };
  },
  metaInfo() {
    return {
      title: "Milestones"
    };
  }
};
</script>
